import { render, staticRenderFns } from "./ManageMvps.vue?vue&type=template&id=015c9149&scoped=true&"
import script from "./ManageMvps.vue?vue&type=script&lang=js&"
export * from "./ManageMvps.vue?vue&type=script&lang=js&"
import style0 from "./ManageMvps.vue?vue&type=style&index=0&id=015c9149&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015c9149",
  null
  
)

export default component.exports